module.exports = __webpack_public_path__ + "img/dynamic-17.08c8338d.png";